import React from "react";
import { Modal, Button } from "react-bootstrap";

const ConfirmacaoAproveitamentoModal = ({
  show,
  onHide,
  onConfirm,
  examName,
}) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirmar Aproveitamento</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h5 className="text-center mb-4">
          Confirmar utilizar aproveitamento de <br />
          <span className="text-primary font-weight-bold">{examName}</span>?
        </h5>
        <p className="text-muted text-center small">
          Ao confirmar, será enviada somente a nota deste exame.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onHide}>
          Cancelar
        </Button>
        <Button variant="success" onClick={onConfirm}>
          Confirmar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmacaoAproveitamentoModal;
